import {
	Login
} from "@/api/complete"
import $router from '@/router/index.js'
// 引入插件
import {
	Message
} from 'element-ui';
export default {
	state: {
		user: { //用户数据
			name: "",
			score: null,
		},
		token: ''
	},
	mutations: {
		SET_USER(state, data) {
			state.user = data;
			localStorage.setItem("user", JSON.stringify(data))
		},
		SET_TOKEN(state, data) {
			state.token = data;
			localStorage.setItem("token", data);
			// 设置最后活动时间
			localStorage.setItem("lastActiveTime", new Date().getTime().toString());
		},
		CLEAR_USER_INFO(state) {
			state.user = { name: "", score: null };
			state.token = '';
			localStorage.removeItem('token');
			localStorage.removeItem('user');
			localStorage.removeItem('lastActiveTime');
		}
	},
	actions: {
		login(context, data) {
			Login(data)
				.then(res => {
					if (res.data.code == 200) {
						console.log('登录响应:', res.data);
						// 存储用户信息，注意res.data.data包含了用户信息
						context.commit("SET_USER", res.data.data);
						// 存储token，从res.data.data.token获取
						context.commit("SET_TOKEN", res.data.data.token);
						Message({
							message: '登录成功',
							type: 'success',
							duration: 1500
						});
						$router.push("/first"); //跳转至主页面
					} else {
						Message({
							message: res.data.message || '登录失败',
							type: 'warning',
							duration: 1500
						})
					}
				})
				.catch(err => {
					console.error('登录错误:', err);
					Message({
						message: '登录失败，请检查网络连接',
						type: 'error',
						duration: 1500
					});
				})
		},
		// 退出登录
		logout(context) {
			return new Promise((resolve) => {
				context.commit('CLEAR_USER_INFO');
				Message({
					message: '已退出登录',
					type: 'success',
					duration: 1500
				});
				resolve();
			});
		}
	}
}
